import {Box, Typography} from '@mui/material';
import {FC} from 'react';

interface IIsActiveStatus {
  isActive: boolean;
}

const boxStyle = {
  borderRadius: '5px',
  padding: '3px 12.5px',
};

const IsActiveStatus: FC<IIsActiveStatus> = ({isActive}) => {
  return (
    <Box
      sx={{
        ...boxStyle,
        background: isActive ? '#DAF5E6' : '#FFDEDE',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
      }}
    >
      <Typography sx={{fontSize: '12px', color: isActive ? '#3AC977' : '#FF5E5E'}}>
        {isActive ? 'Активный' : 'Неактивный'}
      </Typography>
    </Box>
  );
};

export default IsActiveStatus;
